var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.75001H4.25L8.3625 2.63751C8.47966 2.52131 8.57265 2.38306 8.63612 2.23074C8.69958 2.07841 8.73225 1.91503 8.73225 1.75001C8.73225 1.585 8.69958 1.42162 8.63612 1.26929C8.57265 1.11697 8.47966 0.978718 8.3625 0.862514C8.1283 0.6297 7.81148 0.499023 7.48125 0.499023C7.15102 0.499023 6.8342 0.6297 6.6 0.862514L1.2375 6.23751C0.768015 6.7042 0.502791 7.33804 0.5 8.00001C0.506083 8.65765 0.771056 9.28639 1.2375 9.75001L6.6 15.125C6.71655 15.2407 6.85475 15.3324 7.00671 15.3947C7.15868 15.457 7.32143 15.4888 7.48567 15.4882C7.64991 15.4876 7.81244 15.4547 7.96395 15.3913C8.11547 15.3279 8.25302 15.2353 8.36875 15.1188C8.48448 15.0022 8.57612 14.864 8.63843 14.7121C8.70075 14.5601 8.73253 14.3973 8.73195 14.2331C8.73137 14.0688 8.69844 13.9063 8.63505 13.7548C8.57166 13.6033 8.47905 13.4657 8.3625 13.35L4.25 9.25001H16.75C17.0815 9.25001 17.3995 9.11832 17.6339 8.8839C17.8683 8.64948 18 8.33153 18 8.00001C18 7.66849 17.8683 7.35055 17.6339 7.11613C17.3995 6.88171 17.0815 6.75001 16.75 6.75001Z",
    fill: "#3B3F4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.0e5ba395076d4b5193adb17024f901fd.svg";
export { ForwardRef as ReactComponent };